import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { Box, Button, Card, CardContent, CardHeader, CircularProgress, Dialog, DialogContent, Divider, Grid, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SendIcon from '@mui/icons-material/Send';
import { forgotMyPasswordTC } from './auth-reducer';

var validator = require('validator');


type PropsType = {
}

export const ForgotPasswordAlert = React.memo((props: PropsType) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [open, setOpen] = React.useState(false)
  const [span, setSpan] = useState('none')
  const [email, setEmail] = useState('')
  const [err, setError] = useState(false)
  const [isInProgress, SetProgress] = useState(false)

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = useCallback(() => {
    setOpen(false);
    setSpan('none')
  }, []);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value)
  }

  async function sendEmail() {
    SetProgress(true)
    let isValid = validator.isEmail(email)
    if (isValid) {
      handleClose()
      const res = await dispatch(forgotMyPasswordTC({ email }))
      console.log('RES AWAIT: ', res)

      SetProgress(false)
    } else {
      SetProgress(false)
      setSpan('inline')

    }
  }

  return (
    <>
      <Dialog open={isInProgress} >
        <CircularProgress color="info" thickness={4} size={60} style={{ position: 'fixed', marginTop: '0px', left: '50%', width: 100, height: 100 }} />
      </Dialog>
      <Typography onClick={handleClickOpen} variant='caption' className='forgotPassword'>Forgot your password?</Typography>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Grid container style={{ justifyContent: 'end' }}>
          <Grid item >
            <CloseIcon onClick={handleClose} style={{ marginRight: ' 2px', cursor: 'pointer' }} />
          </Grid>
        </Grid>
        <DialogContent >
          <Grid container >
            <Card variant="outlined" style={{ minWidth: '500px' }}>
              {span === 'inline' ?
                <CardContent style={{ width: '400px', textAlign: 'center' }}>
                  <Typography style={{ marginRight: '10px', color: '#24bced', display: `${span}` }} > Please enter correct email!</Typography>
                </CardContent>
                : <>
                  <CardHeader
                    title="Enter your email: "
                  />
                  <Divider />
                  <CardContent >
                    <TextField
                      fullWidth
                      error={err}
                      label="email"
                      margin="normal"
                      name="password"
                      onChange={handleChange}
                      type="email"
                      value={email}
                      variant="outlined"
                    />
                  </CardContent>
                  <Divider />
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      p: 2
                    }}
                  >

                    <Button
                      color="info"
                      variant="contained"
                      onClick={sendEmail}
                      endIcon={<SendIcon fontSize='medium' />}
                    >
                      Send
                    </Button>
                  </Box>
                </>}
            </Card>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}
)
